import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'

import { THEME_GREY } from '../../theme/theme'
import { margin, SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import SectionHeader from '../section-header'
import ResponsiveImage from '../responsive-image'

import { Inner, MemberContainer, MemberContent, MemberInner, MemberInfo, MemberText, LinkedIn, Photo, Name, Role } from './team.styles'


const Team = ({label,heading,items,overlap,overlapSmall,count}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				{heading && <SectionHeader label={label} heading={heading} />}
				<Inner>
					{items.map((item,index) => 
						<MemberContainer key={index}>
							
							<MemberContent>
								<MemberInner>
									{item.photo && <ResponsiveImage image={item.photo} lazy aspectRatio={{width:1,height:1}} sizes={{medium:{span:4}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:2})})`}} />}
									<MemberInfo>
										<MemberText>
											<Name>{item.name}</Name>
											<Role>{item.role}</Role>
										</MemberText>
										{item.linkedin && item.linkedin.url &&
											<LinkedIn href={item.linkedin.url} target="_blank">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path fillRule="evenodd" clipRule="evenodd" d="M0 2.00495C0 0.897645 0.897026 0 2.00495 0H21.9951C23.1024 0 24 0.897026 24 2.00495V21.9951C24 23.1024 23.103 24 21.9951 24H2.00495C0.897645 24 0 23.103 0 21.9951V2.00495ZM9.5 9.15H12.75V10.783C13.2185 9.844 14.419 9 16.2225 9C19.6795 9 20.5 10.869 20.5 14.2985V20.65H17V15.0795C17 13.1265 16.5315 12.025 15.34 12.025C13.6875 12.025 13 13.2125 13 15.0795V20.65H9.5V9.15ZM3.5 20.5H7V9H3.5V20.5ZM7.5 5.25C7.5 6.4925 6.4925 7.5 5.25 7.5C4.0075 7.5 3 6.4925 3 5.25C3 4.0075 4.0075 3 5.25 3C6.4925 3 7.5 4.0075 7.5 5.25Z" fill="#4A90F7"/>
												</svg>
											</LinkedIn>
										}
									</MemberInfo>
								</MemberInner>
							</MemberContent>
						</MemberContainer>
					)}
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Team;